<ion-header *ngIf="showHeader" [translucent]="true">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
      <ion-button (click)="fechar()">
        <ion-icon name="arrow-back-outline"/>
      </ion-button>
    </ion-buttons>
    <ion-title>Tracking</ion-title>
  </ion-toolbar>
</ion-header>

<div id="mapId" style="width: 100%; height: 100%">
</div>


